import React, { useState } from "react";
import FormBox from "../../components/FormBox/FormBox";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { LiHandleButton } from "../../Utils/CustomComponent";
import CommonGrid from "../../components/CommonGrid";
import { gridColumns_PayoffCharges, gridColumns_PayoffFee } from "../../Utils/TableColumnDefs";
import AddCharges from "./TabForms/AddCharges";
import AddFees from "./TabForms/AddFees";
import AddRecipients from "./TabForms/AddRecipients";
import { generatedFields, payoffDemandArr } from "./DemandConstants";

const CreatePayoff = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [showCharges, setShowCharges] = useState(false);
  const [showFees, setShowFees] = useState(false);
  const [showRecipients, setShowRecipients] = useState(false);
  const [showGenerated, setShowGenerated] = useState(false);

  const {
    handleSubmit,
    register,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  async function onSubmit(data) {}

  const handleBtnClick = (value) => {
    const func = () => setActiveTab(value);
    func();
    // handleSubmit(onSubmit)(func);
  };

  return (
    <section
      className="rounded"
      style={{ background: "#eeeeee", minHeight: "100vh", padding: "10px" }}
    >
      <article className="container-fluid">
        <div className="p-3 pb-0  mt-1">
          <h6>
            <span
              className="linkClick"
              role="button"
              onClick={() => navigate("/demand-payoff")}
            >
              Demand Payoff Loans
            </span>{" "}
            / Pay off demand
          </h6>
        </div>
        <form className="bg-white" onSubmit={handleSubmit(onSubmit)}>
          <div className="p-5">
            <div className="row">
              <div className="mb-4">
                <h4>Pay off demand</h4>
              </div>
              <div className="col-sm-6">
                <FormBox
                  options={payoffDemandArr}
                  register={register}
                  watch={watch}
                  setValue={setValue}
                  errors={errors}
                />
              </div>
              <div className="col-sm-6 p-5">
                {showGenerated
                  ? generatedFields.map((item) => (
                      <dl>
                        <div
                          className="border-bottom py-2 d-flex justify-content-between"
                          style={{ gap: "10rem" }}
                        >
                          <dt className="text-sm text-dark">{item.title}</dt>
                          <dd className="mt-1 text-sm text-dark"></dd>
                        </div>
                      </dl>
                    ))
                  : null}
              </div>
            </div>
            <div className="d-flex justify-content-end mt-5">
              <button
                type="button"
                className="btn btn-secondary me-3"
                onClick={() => navigate("/demand-payoff")}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary text-white">
                Create
              </button>
            </div>
          </div>
        </form>
        <div className="pt-5 mt-5 bg-white">
          <ul className="nav nav-tabs ">
            {tabButtons?.map((data, index) => (
              <LiHandleButton
                key={index}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                label={data.label}
                value={index}
                handleBtnClick={handleBtnClick}
              />
            ))}
          </ul>
          <div style={{ padding: "20px" }} className="bg-white rounded">
            {activeTab === 0 && (
              <TabCompWrapper
                btnLabel={"Add Charges"}
                title="Charges"
                gridColumns={gridColumns_PayoffCharges}
                columnData={[]}
                status={"fulfilled"}
                onClick={() => setShowCharges(true)}
              />
            )}
            {activeTab === 1 && (
              <TabCompWrapper
                btnLabel={"Add Fees"}
                title="Fees"
                gridColumns={gridColumns_PayoffFee}
                columnData={[]}
                status={"fulfilled"}
                onClick={() => setShowFees(true)}
              />
            )}
            {activeTab === 2 && (
              <TabCompWrapper
                btnLabel={"Add Recipients"}
                title="Recipients"
                gridColumns={[]}
                columnData={[]}
                status={"fulfilled"}
                onClick={() => setShowRecipients(true)}
              />
            )}
          </div>
        </div>
      </article>
      <AddCharges showCharges={showCharges} setShowCharges={setShowCharges} />
      <AddFees showFees={showFees} setShowFees={setShowFees} />
      <AddRecipients
        showRecipients={showRecipients}
        setShowRecipients={setShowRecipients}
      />
    </section>
  );
};

export default CreatePayoff;

let tabButtons = [
  {
    label: <p>Charges</p>,
  },
  {
    label: <p>Fees</p>,
  },
  {
    label: <p>Recipients</p>,
  },
];

const TabCompWrapper = ({
  btnLabel,
  title,
  gridColumns,
  columnData,
  status,
  onClick,
}) => {
  return (
    <section>
      <div>
        <div className="d-flex justify-content-end">
          <button
            type="submit"
            className="btn btn-primary text-white"
            onClick={onClick}
          >
            {btnLabel}
          </button>
        </div>
      </div>
      <CommonGrid
        className={"bg-white col-sm-12 mt-5"}
        title={title}
        gridColumns={gridColumns}
        columnData={columnData}
        status={status}
        header={false}
        minHeight={null}
      />
    </section>
  );
};
